import { Select, SelectProps } from 'antd'
import './index.css'
import React from 'react'
interface CustomSelectProps extends SelectProps { }
export const filterOptions = (input: any, option: any) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
const SelectForm: React.FC<CustomSelectProps> = (props) => {
    return (
        <Select
            {...props}
            getPopupContainer={()=>document.body}
            filterOption={filterOptions}
            showSearch
            rootClassName='select_form_custom'
           />
    )
}

export default SelectForm
